import { ButtonPrimary, ButtonTertiary } from "components/Atoms/Button";
import React, { useCallback } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { useOpenSidePanel } from "../SidePanel";
import { ShowSidePanelDetails } from "./ShowSidePanelDetails";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";

export interface ShowSidePanelProps {
  showId: number
  trigger: JSX.Element
  onOpen?: () => void
  canEdit: boolean
}

export const ShowSidePanel = (props: ShowSidePanelProps) => {
  return <DetailSidePanel
    detailUrl={routes.show_Detail(props.showId).absolute}
    apiCall={() => window.CoreApi.Show.GetSidePanelData(props.showId)}
    apiKey="show"
    entityId={props.showId}
    title={site.currentEnvironment.show.singular}
    footerContent={data => <>
      <ButtonPrimary href={routes.show_Detail(props.showId).absolute} label={RESX.Buttons.DetailView} />
      {data.show.permissions.canModify && <ButtonTertiary href={routes.show_Edit(props.showId).absolute} label={RESX.Buttons.btnEdit} />}
    </>}
    onOpen={props.onOpen}
    trigger={<RightClickMenu
      menuItems={rightMenuForSidePanel(routes.show_Detail(props.showId).absolute)}
    >
      {props.trigger}
    </RightClickMenu>}
  >
    {(data) => <ShowSidePanelDetails
      data={data}
      canEdit={props.canEdit}
    />}
  </DetailSidePanel>;
};

export const useOpenShowSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openShowSidePanel = useCallback((showId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Show.GetSidePanelData(showId)}
      apiKey="show"
      entityId={showId}
      title={site.currentEnvironment.show.singular}
      footerContent={data => <>
        <ButtonPrimary href={routes.show_Detail(showId).absolute} label={RESX.Buttons.DetailView} />
        {data.show.permissions.canModify && <ButtonTertiary href={routes.show_Edit(showId).absolute} label={RESX.Buttons.btnEdit} />}
      </>}
      skipSidePanelBase
    >
      {(data) => <ShowSidePanelDetails
        data={data}
        canEdit={false}
      />}
    </DetailSidePanel>, `show-side-${showId}`);
  }, [openSidePanel]);

  return openShowSidePanel;
}